/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Upload_LabelInputs */

const cs_pm_upload_label = /** @type {(inputs: Pm_Upload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat export inzerátů (JSON / CSV)`)
};

const en_pm_upload_label = /** @type {(inputs: Pm_Upload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose listing export (JSON / CSV)`)
};

/**
* | output |
* | --- |
* | "Choose listing export (JSON / CSV)" |
*
* @param {Pm_Upload_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_upload_label = /** @type {((inputs?: Pm_Upload_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Upload_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_upload_label(inputs)
	return cs_pm_upload_label(inputs)
});